import { axiosMM } from "./axiosCreator";
import { BFF_API } from "./constants";
import { decamelize } from "./utils";

// import mock from "./mocks/prices-api";

/**
 * Retorna Array de trechos com os melhores preços de cada dia
 * @param {Object} options Objeto que personaliza query string
 * @param {String} options.period "week"|"fortnight"|"month"|"quarter"|"half"|"year"
 * @param {String} options.from IATA da origem
 * @param {String} options.to IATA do destino
 * @param {String} options.searchBy "trend"|"best_price"
 * @param {String} options.airline CIA aérea
 * @param {String} options.tripType "OW"|"RT"
 */
export const getPriceCalendar = options => {
	const query = Object.keys(options).reduce(
		(str, opt, i, self) =>
			`${str}${decamelize(opt)}=${options[opt]}${self.length - 1 == i ? "" : "&"}`,
		""
	);

	// return new Promise(resolve => resolve({ data: mock })) // mock
	return axiosMM.get(`${BFF_API}/best-prices/flights-calendar?${query}`);
};

/**
 * Retorna Array de trechos com os melhores preços de cada dia
 * @param {Object} options Objeto que personaliza query string
 * @param {String} options.from IATA da origem
 * @param {String} options.to IATA do destino
 * @param {String} options.tripType "OW"|"RT"
 * @param {String} options.outbound "yyyy-mm-dd"
 */
export const getPriceCalendarV2 = options => {
	const query = Object.keys(options).reduce(
		(str, opt, i, self) =>
			`${str}${decamelize(opt)}=${options[opt]}${self.length - 1 == i ? "" : "&"}`,
		""
	);

	// return new Promise(resolve => resolve({ data: mock })) // mock
	return axiosMM.get(`${BFF_API}/best-prices/flights-calendar?${query}`);
};

/**
 * Retorna Array de trechos com os melhores preços de cada dia
 * @param {Object} options Objeto que personaliza query string
 * @param {String} options.from IATA da origem
 * @param {String} options.to IATA do destino
 * @param {String} options.tripType "OW"|"RT"
 * @param {String} options.outbound "yyyy-mm-dd"
 */
export const getPriceCalendarV3 = options => {
	const query = Object.keys(options).reduce(
		(str, opt, i, self) =>
			`${str}${decamelize(opt)}=${options[opt]}${self.length - 1 == i ? "" : "&"}`,
		""
	);

	// return new Promise(resolve => resolve({ data: mock })); // mock
	return axiosMM.get(`${BFF_API}/best-prices/flights-calendar?${query}`);
};
